import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
  
  
export const useHasBackPage = (): any => {
    const handleHasBackPage = () => {
        return window.history.length > 1;
    }

    const location = useLocation();

    const [hasBackPage, setHasBackPage] = useState<boolean | undefined>(handleHasBackPage())

    useEffect(() => {
        setHasBackPage(handleHasBackPage())
    }, [
        location
    ])

  return {
    hasBackPage
  }
}